module.exports = __webpack_public_path__ + "static/img/wing_695.e5981fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_695.jpg
// module id = rjDq
// module chunks = 0